import React from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import "./NavigationButtons.css";

const MySpaceButton = ({ title = "My Space", disabled = false }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    navigate('/myspace');
  };

  return (
    <button
      className="nav-button nav-button-myspace"
      onClick={disabled ? undefined : handleClick}
      title={title}
      disabled={disabled}
    >
      <Home size={18} strokeWidth={2} />
    </button>
  );
};

export default MySpaceButton;
